import { useEffect, type FC } from "react"

import { atom, useRecoilState } from "recoil"

import Button from "~/components/Button"
import { Modal, usePortal } from "~/components/ui"
import { Wrapper } from "~/containers/Proposal/state/notifications/QueryErrorModal"

export const enfinErrorMessageState = atom<string>({
  key: `enfinErrorMessage`,
  default: ``,
})

export const EnfinErrorModal: FC = () => {
  const { Portal, show, hide } = usePortal({ elementId: `enfin-error-modal` })
  const [error, setError] = useRecoilState(enfinErrorMessageState)

  useEffect(() => {
    if (error) {
      show()
    }
  }, [error, show])

  const handleClose = () => {
    setError(``)
    hide()
  }

  return (
    <Portal>
      {` `}
      <Modal onClose={handleClose}>
        <Wrapper>
          <header>
            <h1>Something went wrong, sorry for the inconvenience</h1>
            <h2>
              Please refer to the error message below and reload the page to try
              again
            </h2>
          </header>
          <section>
            <p>Error: {error}</p>
            <a href={`mailto:support@powur.com?subject=PowurVisionError:${``}`}>
              Report this issue to the Vision support team
            </a>
            <Button variant="solid" onClick={() => window.location.reload()}>
              Refresh
            </Button>
          </section>
        </Wrapper>
      </Modal>
    </Portal>
  )
}
